"use strict";

exports.__esModule = true;
exports.default = {
    TAB: 9,
    ENTER: 13,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
};